import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { SeoService } from './seo/seo.service';

// Declared by AppModule rather than standalone: it is the module's bootstrap
// component, and a standalone component in `bootstrap: []` makes the dev server's
// incremental rebuild fail with NG6009 while a full build passes. That combination
// serves a stale bundle silently, which is worse than either outcome.
@Component({
  selector: 'app-root',
  template: '<router-outlet />',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent implements OnInit {
  private readonly seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.init();
  }
}
